import { Component, Output, EventEmitter, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { HeaderComponent } from "../components/header/header.component";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { SubheaderComponent } from "../components/subheader/subheader.component";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { InputNumberModule } from "primeng/inputnumber";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TEU_LOGO_GREEN_SVG } from "../assets/constants";

@Component({
  selector: "app-credit-history",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderComponent,
    SidebarComponent,
    SubheaderComponent,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    CalendarModule,
    ButtonModule,
    InputNumberModule,
  ],
  templateUrl: "./credit-history.component.html",
  styleUrl: "./credit-history.component.css",
})
export class CreditHistoryComponent implements OnInit {
  creditHistoryForm!: FormGroup;
  teuLogoGreen: SafeHtml = "";

  constructor(
    private router: Router, 
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {
    this.teuLogoGreen =
      this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_GREEN_SVG);
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  @Output() backToWelcome = new EventEmitter<void>();
  @Output() navigateToNext = new EventEmitter<void>();

  private initializeForm(): void {
    this.creditHistoryForm = this.fb.group({
      acceptConsent: [false, [Validators.requiredTrue]]
    });
  }

  // Métodos para obtener controles del formulario
  get acceptConsent() { return this.creditHistoryForm.get('acceptConsent'); }

  // Método para obtener mensajes de error
  getErrorMessage(fieldName: string): string {
    const field = this.creditHistoryForm.get(fieldName);
    if (field?.errors && field.touched) {
      if (field.errors['required']) {
        return 'Debe aceptar la revisión del historial crediticio';
      }
    }
    return '';
  }

  get canContinue(): boolean {
    return this.creditHistoryForm.valid;
  }

  goBack(): void {
    this.router.navigate(['/upload-documents']);
  }

  onSubmit(): void {
    if (this.creditHistoryForm.valid) {
      const formData = this.creditHistoryForm.value;
      console.log('Historial crediticio enviado:', formData);
      this.router.navigate(['/pending-evaluation']);
    } else {
      // Marcar todos los campos como tocados para mostrar errores
      Object.keys(this.creditHistoryForm.controls).forEach(key => {
        this.creditHistoryForm.get(key)?.markAsTouched();
      });
    }
  }
}
